import SlideToggle from "react-slide-toggle";

interface Props {
  lyrics: string;
  title: string;
}

const SongBlock = (props: Props) => {
  return (
    <div className="border-b border-gray-300 border-solid">
      <SlideToggle
        collapsed
        render={({ toggle, setCollapsibleElement }: any) => (
          <>
            <h3
              className="py-4 text-2xl hover:bg-gray-100 cursor-pointer"
              onClick={toggle}
            >
              {props.title}
            </h3>
            <div
              className="font-mono text-sm p-2 bg-gray-50"
              ref={setCollapsibleElement}
            >
              {props.lyrics.split('\n').map((line, index) => {
                if (line.startsWith('# ')) {
                  return <p key={index} className="text-sm"><b>{line.substring(2)}</b></p>
                } else if (line.length > 0) {
                  return <p key={index} className="text-sm">{line}</p>
                } else {
                  return <br key={index} />
                }
              })}
            </div>
          </>
        )}
      />
    </div>
  );
};

export default SongBlock;